/* @flow */
import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import { fromJS } from 'immutable';
import { prop } from 'ramda';
import * as DataFeeds from 'modules/data-feeds';
import createDebugger from 'debug';
import { querystring } from 'trustar/utils';

const debug = createDebugger('app:modules:data-feeds:epics'); // eslint-disable-line no-unused-vars

import { FEEDS_ENDPOINT } from './constants.js';

import {
  FETCH_ALL,
  FETCH_ALL_SUCCESS,
  FETCH_ALL_FAILURE,
  SUBSCRIBE,
  SUBSCRIBE_SUCCESS,
  SUBSCRIBE_FAILURE,
} from './action-types.js';
import { fetch as fetchEnclaves } from 'modules/enclave/actions.js';
import { fetch as fetchProfile } from 'modules/profile/actions.js';



/** Fetch all data feeds */
const fetchAllEpic = (action$, store, { ajax }) =>
  action$.ofType(FETCH_ALL)
    .mergeMap(() =>
      ajax.get(`${FEEDS_ENDPOINT}`)
      .map(({ response }) => ({
        type: FETCH_ALL_SUCCESS,
        payload: response,
      }))
      .catch(err => Observable.of({
        type: FETCH_ALL_FAILURE,
        error: true,
        payload: err,
      })));

/** Subscribe to a data feed */
const subscribeEpic = (action$, store, { ajax }) =>
  action$.ofType(SUBSCRIBE)
    .mergeMap(({ payload: { id, credentials, origin } }) => {
      const state = store.getState();
      const credentialsType = DataFeeds.getters.feed(id)(state).credentialsType;
      // Sending data as a RequestBody
      const data = credentials.set('credentialsType', credentialsType);
      return ajax.postJSON(querystring({ origin }, `${FEEDS_ENDPOINT}/${id}/subscribe`), data)
       .mergeMap(({ response }) => {
         return [{
           type: SUBSCRIBE_SUCCESS,
           payload: response,
           meta: {
             alert: { type: 'success', text: 'Subscribed successfully.' },
           },
         }, fetchEnclaves(), fetchProfile()];
       })
       .catch(err => {
           const errMsg = (err.status >= 400) && (err.status < 500) ? err.response.message : ''
         return Observable.of({
           type: SUBSCRIBE_FAILURE,
           meta: {
             alert: { type: 'error', text: `Subscription failed. ${errMsg}` },
           },
         });
       });
    });


/** Export all data-feed epics */
export default combineEpics(
  fetchAllEpic,
  subscribeEpic,
);



// WEBPACK FOOTER //
// ./src/app/modules/data-feeds/epics.js